<template>
  <div>
    <v-text-field
      :disabled="disabled"
      @blur="onBlurNumber"
      @input="dispatch"
      :label="label"
      type="number"
      v-if="visible === true"
      v-model="amount"
    >
    </v-text-field>

    <v-text-field
      :disabled="disabled"
      @focus="onFocusText"
      :label="label"
      type="text"
      v-if="visible === false"
      v-model="amount"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "InputSeparatore",
  components: {},
  props: {
    decimali_fissi: { type: Boolean, default: false },
    destinazione: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
    numero_decimali: { type: Number, default: 2 },
  },
  data() {
    return { amount: 0, temp: null, visible: false, numero_iniziale: "0" };
  },
  watch: {
    numero_iniziale: {
      immediate: true,
      handler() {
        this.amount = this.thousandSeprator(this.numero_iniziale);
        this.temp = parseInt(this.numero_iniziale);
      },
    },
  },
  methods: {
    dispatch() {
      // Compongo un messaggio.
      const numero = parseFloat(this.amount.toString().replace(",", "."));

      this.$emit("input", numero);
    },
    onBlurNumber() {
      if (this.decimali_fissi === false) {
        this.visible = false;
        /* temp is used to holding the original
         * value before separator is applied. */
        this.temp = this.amount;
        /* this.thousandSeprator is a function used to apply
         * separator into user input */
         this.amount = this.thousandSeprator(Number(this.amount));
      } else {
        // Chiudo il dialog
        this.visible = false;

        // Tronco al secondo decimale.
        this.amount =
          Math.trunc(this.amount * (10 ** this.numero_decimali)) / (10 ** this.numero_decimali);

        /* temp is used to holding the original
         * value before separator is applied. */
        this.temp = this.amount;
        /* this.thousandSeprator is a function used to apply
         * separator into user input */
        this.amount = this.thousandSeprator(this.amount);
      }
    },
    onFocusText() {
      this.visible = true;
      /**
       * temp is used to holding the original
       * value before separator is applied
       */
      this.amount = this.temp;
    },

    /*Replace numbers with comma separated value*/
    thousandSeprator(amount) {
      if (this.decimali_fissi === false) {
        if (
          amount !== "" ||
          amount !== undefined ||
          amount !== 0 ||
          amount !== "0" ||
          amount !== null
        ) {
          amount = amount.toString().replace(".", ",");
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
          return "0";
        }
      } else {
        if (
          amount !== "" ||
          amount !== undefined ||
          amount !== 0 ||
          amount !== "0" ||
          amount !== null
        ) {
          // Imposto il numero con il numero di decimali indicato.
          amount = parseFloat(amount).toFixed(this.numero_decimali);

          // Rimpiazzo il separatore decimale con la virgola.
          amount = amount.replace(".", ",");

          // Divido il numero nella parte intera e decimale.
          let amount_init = amount.split(",")[0];
          let amount_final = amount.split(",")[1];
          
          // Aggiungo un punto ogni 3 posti per le migliaia.
          amount_init = amount_init.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

          // Monto la stringa finale con la virgola come searatore decimale.
          amount = amount_init + "," + amount_final;
          return amount;
        } else {
          let res = "0,";
          for (let i = 0; i < this.numero_decimali; i++) {
            res += "0";
          }
          return res;
        }
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
</style>